<template>
  <div class="freestyle-container">
    <AudioControl />
    <div
      class="freestyle-container--border"
    >
      <div
        v-if="slideActive.backgroundImage"
        class="freestyle-container--background-wrapper"
        :style="{
          'background-image': 'url(' + slideActive.backgroundImage.large + ')' ,
          'background-size': 'cover',
          opacity: slideActive.visibility / 100
        }"
      />
      <div
        v-if="slideActive.image"
        class="freestyle-container--background-wrapper"
        :style="{
          'background-image': 'url(' + slideActive.image.large + ')' ,
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center'

        }"
      />
      <div class="freestyle-container--thumbnail-wrapper">
        <FreestyleThumbnailPreview :slide="slideActive" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import FreestyleThumbnailPreview from './freestyle/FreestyleThumbnailPreview.vue'
import EventBus from '../../eventBus'
import AudioControl from '../AudioControl.vue'

export default {
  components: {
    FreestyleThumbnailPreview,
    AudioControl,
  },
  computed: {
    ...mapGetters({
      slideActive: 'activeActivity',
    }),
  },
  watch: {
    slideActive(newVal, oldVal) {
      if (newVal.id != oldVal.id && newVal.canvasBlocksUrl != oldVal.canvasBlocksUrl) {
        this.loadCanvasBlocks({
          slideId: newVal.id,
          canvasBlocksUrl: newVal.canvasBlocksUrl,
          canvasBlocks: newVal.canvasBlocks,
        })
      }
    },
  },
  async mounted() {
    this.loadCanvasBlocks({
      slideId: this.slideActive.id,
      canvasBlocksUrl: this.slideActive.canvasBlocksUrl,
      canvasBlocks: this.slideActive.canvasBlocks,
    })
    EventBus.$on('update-canvas-blocks', (data) => {
      this.loadCanvasBlocks(data)
    })
  },
  destroyed() {
    EventBus.$off('update-canvas-blocks')
  },
  methods: {
    async loadCanvasBlocks(data) {
      if (data.slideId !== this.slideActive.id) return

      if (data.canvasBlocksUrl && data.canvasBlocks) {
        this.$store.dispatch('updateSlide', {
          canvasBlocks: data.canvasBlocks,
          canvasBlocksUrl: data.canvasBlocksUrl,
          id: data.slideId,
        })
        return
      }

      let canvasBlocks = {}
      if (data.canvasBlocksUrl) {
        const res = await this.$http.get(data.canvasBlocksUrl)
        if (res.body) {
          canvasBlocks = res.body
        }
      }

      this.$store.dispatch('updateSlide', {
        canvasBlocks,
        canvasBlocksUrl: data.canvasBlocksUrl,
        id: data.slideId,
      })
    },
  },

}
</script>

<style lang="scss" scoped>
  .freestyle-container {
    padding: 0 16px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
.freestyle-container--border {
  margin-top: 20px;
  width: 100%;
  padding-top: 56.25%;
  border-radius: 4px;
  border: 1px solid #ccc;
  overflow: hidden;
  position: relative;
}

.freestyle-container--background-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

.freestyle-container--thumbnail-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
}

</style>
